import { CheckSquare, Clock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useQuickTasks } from '@/hooks/useQuickTasks';
import { QuickTaskInput } from '@/components/quick-tasks/QuickTaskInput';
import { QuickTaskItem } from '@/components/quick-tasks/QuickTaskItem';

export function QuickTasksContent() {
  const {
    tasks,
    completedCount,
    addTask,
    toggleTask,
    deleteTask,
    updateTask,
    clearCompleted,
  } = useQuickTasks();

  return (
    <div className="bg-teal-50/50 dark:bg-teal-950/20 p-3 space-y-3">
      {/* TODAY Badge */}
      <div className="flex items-center justify-between">
        <span className="inline-flex items-center gap-1.5 text-xs font-semibold bg-teal-500 text-white px-2.5 py-1 rounded-full">
          <Clock className="h-3 w-3" />
          TODAY
        </span>
        <span className="text-xs text-teal-600 dark:text-teal-400">
          Fresh list every day
        </span>
      </div>

      {/* Task Input */}
      <QuickTaskInput onAdd={addTask} />

      {/* Task List */}
      {tasks.length > 0 ? (
        <div className="max-h-48 overflow-y-auto space-y-1">
          {tasks.map(task => (
            <QuickTaskItem
              key={task.id}
              task={task}
              onToggle={toggleTask}
              onDelete={deleteTask}
              onUpdate={updateTask}
            />
          ))}
        </div>
      ) : (
        <div className="text-center py-6 bg-teal-100/50 dark:bg-teal-900/30 rounded-lg border border-teal-200 dark:border-teal-800">
          <div className="flex items-center justify-center gap-2 mb-2">
            <CheckSquare className="h-5 w-5 text-teal-500" />
            <span className="font-semibold text-teal-700 dark:text-teal-300">Your Daily To-Do List</span>
          </div>
          <p className="text-xs text-teal-600 dark:text-teal-400 max-w-xs mx-auto">
            Nothing on your list yet — add your first to-do above!
          </p>
        </div>
      )}

      {/* Clear Completed */}
      {completedCount > 0 && (
        <div className="flex justify-end pt-2 border-t border-teal-200 dark:border-teal-800">
          <Button
            variant="ghost"
            size="sm"
            onClick={clearCompleted}
            className="text-xs text-teal-600 dark:text-teal-400 hover:bg-teal-100 dark:hover:bg-teal-900/50"
          >
            Clear {completedCount} completed
          </Button>
        </div>
      )}
    </div>
  );
}
